export default __webpack_public_path__ + "static/media/imm-lavora.7f5fc656.png";